import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {setLanguage} from "redux-i18n";
import { connect } from 'react-redux';

const styles = theme => ({
    root: {

    },
    menuStyle:{
        // marginLeft:'33px'
    }
});

class ChangeLangaugeMenu extends Component {
  state = {
    value: 0,
    languages: ['English', '中文'],
    lan: ['en', 'cn'],
  };

  componentDidMount(){
      this.setState({
          value: this.state.lan.findIndex(lan => lan === this.props.lang)
      })
  }

    handleChangeSelect = event => {
        this.props.setLanguage(this.state.lan[event.target.value]);
        this.setState({ [event.target.name]: event.target.value });
        console.log('handleChangeSelect language: event.target.value: '+event.target.value+' event.target.name: '+event.target.name)
        localStorage.setItem('language', this.state.lan[event.target.value]);
        
        setTimeout(()=>{
            window.location.reload();
        },1000)
    };

  render() {
    const {classes} = this.props;
    const { value, languages } = this.state;
    return (
        <div className={classes.menuStyle}>
            <form autoComplete="off">
                <FormControl style={{width:'100%'}} className={classes.isMobileFormControl}>
                    <Select
                        value={this.state.value}
                        onChange={this.handleChangeSelect}
                        
                        inputProps={{
                        name: 'value',
                        id: 'select-navTabs'
                        }}
                        SelectDisplayProps={{
                            style: {fontSize: 13, color:'white', textAlign:'center'},
                        }}
                    >
                        <MenuItem value={0}>{languages[0]}</MenuItem>
                        <MenuItem value={1}>{languages[1]}</MenuItem>
                    </Select>
                </FormControl>
            </form>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
    return {
        lang: state.i18nState.lang,
    }
    
}

const mapDispatchToProps = (dispatch) => {
    return {
        setLanguage: (language) => dispatch(setLanguage(language)),
    }
}

ChangeLangaugeMenu.contextTypes = {
  t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ChangeLangaugeMenu));